// extracted by mini-css-extract-plugin
export default {"container":"WaterMask_container__Vwb9g"};